import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  Label,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  Modal,
  ModalBody,
  Tooltip,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  gAPI_Property_List_By_Group,
  API_AMAZON_INTEGRATION,
} from '../../../../../../constants/APIs';
import Validation from '../../../../../../components/Validation';
let arr = [];
export default function AmazonIntegration({
  visible,
  toggle,
  id,
  LoadIntegrations,
}) {
  const [property, setProperty] = useState([]);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [maskData, setMaskData] = useState({
    accessSecretKey: '',
    accessKeyId: '',
  });
  const [titleToolTip, settitleToolTip] = useState(false);
  const [showRatesRadios, setRatesRadios] = useState(false);
  const [inputData, setInputData] = useState({
    groupId: getGroupID(),
    name: '',
    properties: [],
    sessionTimeoutInSeconds: 600,
    defaultLanguage: 'en-US',
    accessKeyId: '',
    accessSecretKey: '',
    region: '',
    instanceID: '',
    contactFlowID: '',
  });
  const toggleTitleToolTip = () => {
    settitleToolTip(!titleToolTip);
  };
  useEffect(() => {
    if (id !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${API_AMAZON_INTEGRATION}/${id}?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setInputData({
            ...inputData,
            name: res.data.name,
            properties:
              res.data.properties !== null ? [res.data.properties[0]] : [],
            accessKeyId: res.data.channelDetails.accessKeyId,
            accessSecretKey: res.data.channelDetails.accessSecretKey,
            region: res.data.channelDetails.region,
            contactFlowID: res.data.channelDetails.contactFlowID,
            instanceID: res.data.channelDetails.instanceID,
          });

          setMaskData({
            ...maskData,
            accessSecretKey: mask(res.data.channelDetails.accessSecretKey),
            accessKeyId: mask(res.data.channelDetails.accessKeyId),
          });
        })
        .catch((err) => console.log('err', err));

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    } else {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    }
  }, [id]);
  const mask = (value) => {
    let maskedValue = '';
    for (let i = 0; i < value.length - 2; i++) {
      maskedValue += '*';
    }
    return maskedValue + value.substring(value.length - 2, value.length);
  };

  const handleNameChange = (e) => {
    e.persist();
    setInputData({ ...inputData, name: e.target.value });
  };

  const handleAccessSecretKeyChange = (e) => {
    e.persist();
    setMaskData({ ...maskData, accessSecretKey: mask(e.target.value) });
    setInputData({ ...inputData, accessSecretKey: e.target.value });
  };
  const handleAccessKeyIdChange = (e) => {
    e.persist();
    setMaskData({ ...maskData, accessKeyId: mask(e.target.value) });
    setInputData({ ...inputData, accessKeyId: e.target.value });
  };
  const handleChange = (e) => {
    e.persist();
    setInputData({ ...inputData, [e.target.name]: e.target.value });
  };
  const handleCheckChange = (e) => {
    if (e.target.checked) {
      setInputData({ ...inputData, properties: [e.target.value] });
    }
    if (!e.target.checked) {
      setInputData({ ...inputData, properties: [] });
    }
  };

  const handleSave = async () => {
    if (id !== undefined) {
      AxiosAPI({
        method: 'put',
        url: `${API_AMAZON_INTEGRATION}/${id}?group_id=${getGroupID()}`,
        data: inputData,
      }).then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          toggle();
          setTimeout(() => {
            window.location.reload();
          }, 300);
        }
      });
    } else {
      AxiosAPI({
        method: 'post',
        url: API_AMAZON_INTEGRATION,
        data: inputData,
      }).then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          toggle();
          setTimeout(() => {
            window.location.reload();
          }, 300);
        }
      });
    }
  };

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle}>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <h6>{id === undefined ? 'Add' : 'Update'} Integration</h6>
                <Separator className="mb-3" />
                <Form className="text-left">
                  <FormGroup className="mb-2">
                    <Label>Integration Name</Label>
                    <Input
                      type="text"
                      name="integrationName"
                      onChange={handleNameChange}
                      placeholder="Integration Name"
                      defaultValue={inputData.name}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Region</Label>
                    <Input
                      type="text"
                      name="region"
                      onChange={handleChange}
                      placeholder="Region"
                      defaultValue={inputData.region}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Access Key Id</Label>
                    <Input
                      type="text"
                      name="accessKeyId"
                      onChange={handleAccessKeyIdChange}
                      placeholder="Client Token"
                      defaultValue={maskData.accessKeyId}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Access Secret Key (AWS Identity and Access Management (IAM) permissions)</Label>
                    <Input
                      type="text"
                      name="accessSecretKey"
                      onChange={handleAccessSecretKeyChange}
                      placeholder="Access Secret Key"
                      defaultValue={maskData.accessSecretKey}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Instance Id</Label>
                    <Input
                      type="text"
                      name="instanceID"
                      onChange={handleChange}
                      placeholder="Instance ID"
                      defaultValue={inputData.instanceID}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Contact Flow ID</Label>
                    <Input
                      type="text"
                      name="contactFlowID"
                      onChange={handleChange}
                      placeholder="Contact Flow ID"
                      defaultValue={inputData.contactFlowID}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <div className="integration-property">
                      {property.map((p, index) => {
                        return (
                          <CustomInput
                            key={p.id}
                            type="radio"
                            id={index}
                            label={p.name}
                            value={p.id}
                            name="property"
                            checked={
                              p.id === inputData.properties[0] ? true : false
                            }
                            onChange={handleCheckChange}
                          />
                        );
                      })}
                    </div>
                  </FormGroup>
                </Form>
                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                  {id === undefined ? (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Create New Integration
                    </Button>
                  ) : (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Update Integration
                    </Button>
                  )}
                  <Button size="xs" color="dark" outline onClick={toggle}>
                    Cancel
                  </Button>
                </ButtonGroup>
              </div>
            </Colxx>
          </Row>
        </ModalBody>
      </Modal>
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </Fragment>
  );
}
